import { download } from '@/api/invitation';
import { Toast } from 'antd-mobile';

/**
 * 保存用户信息
 */
export const setUserInfo = (tokenName: string, tokenValue: any) => {
  localStorage.setItem('tokenName', tokenName);
  localStorage.setItem(tokenName, tokenValue);
};

/**
 * 清除用户信息
 */
export const clearUserInfo = () => {
  const tokenName: any = localStorage.getItem('tokenName');
  tokenName && localStorage.removeItem(tokenName);
  localStorage.removeItem('tokenName');
  localStorage.removeItem('phoneNumber');
};

/**
 * 获取url参数
 * @param search url参数
 */
export const searchObj = (search: string) => {
  const body = JSON.parse(
    '{"'.concat(
      decodeURIComponent(search.substring(1))
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"'),
      '"}',
    ),
  );
  return body;
};

export const treeToList = (list: any[], parents: string | string[]) => {
  let adtaList: any[] = [];
  list.forEach((v) => {
    if (typeof parents === 'string') {
      if (v[parents]) {
        adtaList = [...adtaList, ...treeToList(v[parents], parents)];
      } else {
        adtaList.push(v);
      }
    } else {
      let isHave = false;
      parents.forEach((parent) => {
        if (v[parent]) {
          adtaList = [...adtaList, ...treeToList(v[parent], parents)];
          isHave = true;
        }
      });
      if (!isHave) {
        adtaList.push(v);
      }
    }
  });
  return adtaList;
};

export const setWindowHeight = () => {
  const windowWidth = window.innerWidth;
  let windowHeight = window.innerHeight;
  if (typeof windowWidth !== 'number') {
    if (document.compatMode === 'CSS1Compat') {
      windowHeight = document.documentElement.clientHeight;
    } else {
      // @ts-ignore
      windowHeight = window.body.clientHeight;
    }
  }
  document
    .getElementsByTagName('body')[0]
    .style.setProperty('--height-primary', `${windowHeight}px`);
};

/**
 * 金额千分隔开
 * @param num
 * @param decimalPlaces 小数位
 * @param separator
 * @returns
 */
export const formatCurrency = (
  num: any,
  decimalPlaces: number = 2,
  separator: string = ',',
) => {
  if (isNaN(parseFloat(num))) return num;

  const fixedNum = parseFloat(num).toFixed(decimalPlaces);

  const [integerPart, decimalPart]: any = fixedNum.split('.');

  const formattedInteger = integerPart.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    separator,
  );

  return decimalPart
    ? `${formattedInteger + (decimalPart * 1 ? '.' + decimalPart : '')}`
    : formattedInteger;
};

/**
 * 下载Base64格式图片
 * @param {string} base64Data - 完整Base64数据或纯编码
 * @param {string} [filename] - 自定义文件名（无需扩展名）
 */
export const downloadBase64Image = (base64Data: any, filename = 'qr') => {
  // 标准化Base64数据
  const normalizedData = base64Data.startsWith('data:')
    ? base64Data
    : `data:image/png;base64,${base64Data}`;

  // 解析MIME类型
  const mimeMatch = normalizedData.match(/:(.*?);/);
  const mimeType = mimeMatch ? mimeMatch[1] : 'image/png';
  const extension = mimeType.split('/')[1] || 'png';

  // 转换为Blob
  const byteString = atob(normalizedData.split(',')[1]);
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  const blob = new Blob([ab], { type: mimeType });

  // 触发下载
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${filename}.${extension}`;
  document.body.appendChild(link);
  link.click();

  // 清理
  setTimeout(() => {
    URL.revokeObjectURL(url);
    document.body.removeChild(link);
  }, 100);
};

/**
 * 调起app
 * @param href
 */
export const linkToScheme = (href: string, fn?: any) => {
  if (!href) {
    fn?.();
    return;
  }
  window.location.href = href;
  setTimeout(function () {
    let hidden =
      (window.document as any).hidden ||
      (window.document as any).mozHidden ||
      (window.document as any).msHidden ||
      (window.document as any).webkitHidden;
    if (typeof hidden == 'undefined' || hidden == false) {
      Toast.show({
        content: 'Please install the App first.',
        position: 'top',
      });
      fn?.();
    }
  }, 3000);
};

/**
 * 下载app
 */
export const downLoadApp = async () => {
  const res = await download();
  if (res.data) {
    let dload = document.createElement('a');
    dload.download = '';
    dload.href = res.data;
    document.body.appendChild(dload);
    dload.click();
    dload.remove();
  }
};

/**
 * 判断ios设备类型
 * @returns
 */
export const getAppleDeviceType = () => {
  const ua = navigator.userAgent;
  if (/iPhone/i.test(ua)) return 'iPhone';
  if (/iPad/i.test(ua)) return 'iPad';
  if (/iPod/i.test(ua)) return 'iPod';
  return 'Not Apple';
};

/**
 * 复制到剪切板
 * @param text
 */
export const handleCopy = async (text: any) => {
  try {
    await navigator.clipboard.writeText(text);
    Toast.show({
      icon: 'success',
      content: 'Copy successfully!',
    });
  } catch (err) {
    Toast.show({
      icon: 'error',
      content: 'Copy failed!',
    });
  }
};

/**
 * 密码检查
 * @param str
 */
export const passwordCheck = (pw: string) => {
  const regex: any =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d!@#$%^&*()_+\-=\[\]{};':"\\|,.<>/?]{8,16}$/;
  const vaild = regex.test(pw);
  !vaild &&
    Toast.show({
      content:
        'The password must be 8-16 characters long and contain uppercase and lowercase letters and numbers.',
      duration: 1500,
    });
  return vaild;
};
